import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useCallback } from "react";
export var useGetModalSizing = function(hasImage, isMobile, height, width) {
    var getModalWidthValues = useCallback(function() {
        var modalWidthValues;
        if (isMobile) {
            modalWidthValues = {
                width: "100%",
                minWidth: "100%"
            };
        } else if (width) {
            modalWidthValues = {
                width: width,
                minWidth: width
            };
        } else {
            modalWidthValues = hasImage ? {
                width: "50%",
                minWidth: "810px"
            } : {
                width: "30%",
                minWidth: "383px"
            };
        }
        return modalWidthValues;
    }, [
        hasImage,
        isMobile,
        width
    ]);
    var getModalHeightValues = useCallback(function() {
        var modalHeightValues;
        if (isMobile) {
            modalHeightValues = {
                height: "100%",
                maxHeight: "100vh"
            };
        } else if (height) {
            modalHeightValues = {
                height: height,
                maxHeight: height
            };
        } else {
            modalHeightValues = {
                height: "min-content",
                maxHeight: "80%"
            };
        }
        return modalHeightValues;
    }, [
        isMobile,
        height
    ]);
    return _object_spread({}, getModalWidthValues(), getModalHeightValues());
};
